import { paginationFilters } from './paginationFilters';
import { filterAndSortingKeys } from './filterAndSortingsUtil';
import {
  HEARINGSTATUS_ACTIVE,
  HEARINGSTATUS_AWAITING_STARTDATE,
  HEARINGSTATUS_CONCLUDED,
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGROLE_OWNER,
  HEARINGROLE_RESPONDER,
  HEARINGROLE_REVIEWER,
  HEARINGROLE_INVITEE,
} from '../constants/api';
import { Pages } from '../constants/pages';

export const defaultPageFilters = {
  [Pages.CurrentHearingsPage]: [
    paginationFilters.hearings[filterAndSortingKeys.hearingStatus](
      HEARINGSTATUS_ACTIVE,
    ),
    paginationFilters.hearings[filterAndSortingKeys.hearingStatus](
      HEARINGSTATUS_AWAITING_STARTDATE,
    ),
  ],
  [Pages.MyHearingsPageWritten]: [
    paginationFilters.hearings[filterAndSortingKeys.userHearingRole](
      HEARINGROLE_OWNER,
    ),
  ],
  [Pages.MyHearingsPageResponded]: [
    paginationFilters.hearings[filterAndSortingKeys.userHearingRole](
      HEARINGROLE_RESPONDER,
    ),
  ],
  [Pages.MyHearingsPageReviewed]: [
    paginationFilters.hearings[filterAndSortingKeys.userHearingRole](
      HEARINGROLE_REVIEWER,
    ),
  ],
  [Pages.MyHearingsPageInvited]: [
    paginationFilters.hearings[filterAndSortingKeys.userHearingRole](
      HEARINGROLE_INVITEE,
    ),
  ],
  [Pages.ConcludedHearingsPage]: [
    paginationFilters.hearings[filterAndSortingKeys.hearingStatus](
      HEARINGSTATUS_CONCLUDED,
    ),
    paginationFilters.hearings[filterAndSortingKeys.hearingStatus](
      HEARINGSTATUS_AWAITING_CONCLUSION,
    ),
  ],
  [Pages.AdministrationPage]: [],
};
